import "./BurgerMunch.72d14e9a.js";
import "./BurgerMunch.8ee970a6.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3421"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3421"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2pb0H = parcelRequire("2pb0H");

var $5jD8l = parcelRequire("5jD8l");

var $amjSx = parcelRequire("amjSx");

var $7DG7z = parcelRequire("7DG7z");

var $dlkUe = parcelRequire("dlkUe");

var $gEdkA = parcelRequire("gEdkA");
await (0, $2pb0H.initSite)();
$187d9824843bd3b9$var$renderBranchesPage();
function $187d9824843bd3b9$var$renderBranchesPage() {
    $187d9824843bd3b9$var$renderBranches();
    $187d9824843bd3b9$var$initBranchCards();
    $187d9824843bd3b9$var$initBranchAdminButtons();
    (0, $7DG7z.applyBranchFields)();
    (0, $2pb0H.initReveal)();
    (0, $gEdkA.refreshInlineCms)();
}
function $187d9824843bd3b9$var$renderBranches() {
    const root = document.getElementById("branches-root");
    const actions = document.getElementById("branches-cms-actions");
    if (!root) return;
    root.innerHTML = (0, $amjSx.getBranchList)().map((branch)=>$187d9824843bd3b9$var$renderBranchCard(branch)).join("");
    (0, $5jD8l.injectIcons)();
    if (actions) actions.innerHTML = (0, $amjSx.isAdminAuthed)() ? `<button type="button" class="bm-cms-branch-add" data-cms-branch-add>+ \u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5E1}\u{5E0}\u{5D9}\u{5E3}</button>` : "";
}
function $187d9824843bd3b9$var$renderBranchCard(branch) {
    const name = branch.branch || branch.title || "\u05E1\u05E0\u05D9\u05E3";
    const image = (0, $dlkUe.resolveBranchImageSrc)(branch.id, branch.image);
    const removeBtn = (0, $amjSx.isAdminAuthed)() ? `<button type="button" class="bm-cms-item-remove" data-cms-branch-remove="${branch.id}" aria-label="\u{5D4}\u{5E1}\u{5E8} \u{5D0}\u{5EA} ${name}">\xd7</button>` : "";
    return `
    <article class="product reveal bm-branch-card" data-branch="${branch.id}" tabindex="0" role="button" aria-label="${name}, \u{5DC}\u{5D7}\u{5E6}\u{5D5} \u{5DC}\u{5E4}\u{5E8}\u{5D8}\u{5D9}\u{5DD}">
      ${removeBtn}
      <div class="img-container">
        <img src="${image}" alt="\u{5E1}\u{5E0}\u{5D9}\u{5E3} ${name}" class="product-img" data-cms-branch-prop="image">
        <span class="bag-btn">
          <span class="bm-icon bm-icon--xs" data-icon="arrowRight" aria-hidden="true"></span>
          <span data-cms-key="branches.card.cta">\u{5DC}\u{5E4}\u{5E8}\u{5D8}\u{5D9} \u{5D4}\u{5E1}\u{5E0}\u{5D9}\u{5E3}</span>
        </span>
      </div>
      <h2 data-cms-branch-prop="branch">${name}</h2>
    </article>
  `;
}
function $187d9824843bd3b9$var$initBranchCards() {
    const branches = Object.fromEntries((0, $amjSx.getBranchList)().map((branch)=>[
            branch.id,
            branch
        ]));
    document.querySelectorAll("[data-branch]").forEach((card)=>{
        const id = card.dataset.branch;
        const data = branches[id];
        if (!data) return;
        const go = ()=>$187d9824843bd3b9$var$goToBranch(id, data);
        card.addEventListener("click", go);
        card.addEventListener("keydown", (event)=>{
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                go();
            }
        });
        const btn = card.querySelector(".bag-btn");
        btn?.addEventListener("click", (event)=>{
            event.stopPropagation();
            go();
        });
    });
}
function $187d9824843bd3b9$var$initBranchAdminButtons() {
    if (!(0, $amjSx.isAdminAuthed)()) return;
    document.querySelectorAll("[data-cms-branch-remove]").forEach((btn)=>{
        if (btn.dataset.cmsRemoveReady === "1") return;
        btn.dataset.cmsRemoveReady = "1";
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const branchId = btn.dataset.cmsBranchRemove;
            const name = btn.closest("[data-branch]")?.querySelector("[data-cms-branch-prop='branch']")?.textContent || "\u05D4\u05E1\u05E0\u05D9\u05E3";
            if (!branchId || !confirm(`\u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5D0}\u{5EA} ${name}?`)) return;
            if (!(0, $amjSx.removeBranch)(branchId)) {
                (0, $gEdkA.showCmsToast)("\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05E9\u05D0\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05E1\u05E0\u05D9\u05E3 \u05D0\u05D7\u05D3", "error");
                return;
            }
            $187d9824843bd3b9$var$renderBranchesPage();
            (0, $gEdkA.showCmsToast)("\u05D4\u05E1\u05E0\u05D9\u05E3 \u05D4\u05D5\u05E1\u05E8");
        });
    });
    document.querySelectorAll("[data-cms-branch-add]").forEach((btn)=>{
        if (btn.dataset.cmsAddReady === "1") return;
        btn.dataset.cmsAddReady = "1";
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            const branchId = (0, $amjSx.addBranch)();
            if (!branchId) return;
            $187d9824843bd3b9$var$renderBranchesPage();
            (0, $gEdkA.showCmsToast)("\u05E0\u05D5\u05E1\u05E3 \u05E1\u05E0\u05D9\u05E3 \u05D7\u05D3\u05E9");
            requestAnimationFrame(()=>{
                document.querySelector(`[data-branch="${branchId}"]`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            });
        });
    });
}
function $187d9824843bd3b9$var$goToBranch(id, data) {
    localStorage.setItem("myitem", JSON.stringify({
        ...data,
        id: id
    }));
    window.location.href = "branch.html";
}


//# sourceMappingURL=branches.e542d45a.js.map
